import types from 'actions/types';
import { capitalizedString, typeNotifyOptions } from 'utils/helpers';

const SIDEBAR_COLLAPSED_STORAGE_KEY = 'baochau.portal.sidebar.collapsed';
const getStoredSidebarState = () => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  } catch (_) {
    return false;
  }
};

const INITIAL_STATE = {
  collapsedSideBar: getStoredSidebarState(),
  confirmMessage: undefined,
  confirmCallback: undefined,
  refuseCallback: undefined,
  labelAccept: undefined,
  labelRefuse: undefined,
  // #region notify
  typeNotify: undefined,
  openNotify: false,
  // #endregion
};

export default function globalReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.TRIGGER_SIDEBAR:
      return {
        ...state,
        collapsedSideBar: !state.collapsedSideBar,
      };
    case types.SHOW_CONFIRM_MODAL:
      return {
        ...state,
        confirmMessage: action.payload.message,
        confirmCallback: action.payload.confirmCallback,
        refuseCallback: action.payload.refuseCallback,
        labelAccept: action.payload?.labelAccept,
        labelRefuse: action.payload?.labelRefuse,
      };
    case types.HIDE_CONFIRM_MODAL:
      return {
        ...state,
        confirmMessage: undefined,
        confirmCallback: undefined,
        refuseCallback: undefined,
        labelAccept: undefined,
        labelRefuse: undefined,
      };
    case types.SHOW_NOTIFY:
      return {
        ...state,
        openNotify: true,
        typeNotify: typeNotifyOptions.find((e) => e?.value === action.payload),
      };
    case types.HIDE_NOTIFY: {
      return {
        ...state,
        openNotify: false,
        typeNotify: undefined,
      };
    }
    case types.COUNT_NOTIFY: {
      return {
        ...state,
        count: action.payload,
      };
    }
    default: {
      if (action.type.includes('GET_GLOBAL_OPTIONS')) {
        const fieldType = action.field;
        const fieldLoadingRequest = `get${capitalizedString(fieldType)}Loading`;
        const fieldDataRequest = `${fieldType}Data`;
        const fieldParamsRequest = `${fieldType}Params`;
        if (fieldType === 'supplier' && action.requestId !== undefined && !action.type.includes('REQUEST')
          && action.requestId !== state.supplierRequestId) {
          return state;
        }
        if (action.type.includes('REQUEST')) {
          return {
            ...state,
            ...(fieldType === 'supplier' ? { supplierRequestId: action.requestId } : {}),
            [fieldLoadingRequest]: true,
            // Keep the current options visible while a background refresh is
            // running. This avoids an empty dropdown/flicker for large lists.
            [fieldDataRequest]: state[fieldDataRequest],
            [fieldParamsRequest]: state[fieldParamsRequest],
          };
        }
        if (action.type.includes('SUCCESS')) {
          return {
            ...state,
            [fieldLoadingRequest]: false,
            [fieldDataRequest]: action.payload,
            [fieldParamsRequest]: action.params,
          };
        }
        if (action.type.includes('FAILURE')) {
          return {
            ...state,
            [fieldLoadingRequest]: false,
          };
        }
      }
      return state;
    }
  }
}
